import { FC } from "react";
import { Trans } from "react-i18next";
import { SparklesIcon } from "assets/svg";

import { Text } from "uikit";

import { ModalContent } from "./ModalContent";
import { useAiAssistantModal } from "./useAiAssistantModal";
import { AssistantButton } from "./styles";

const AiAssistantModal: FC = () => {
  const translationPrefix = `ai_assistant_pages.shared.modal`;
  const {
    isOpen,
    handleChangeModal,
    chatHistory,
    isLoading,
    handleSendMessage,
    handleSuggestedActionClick,
    handleNewChat,
    handleSubmitButtonClick,
    handleCancelButtonClick,
  } = useAiAssistantModal();

  return (
    <>
      <AssistantButton
        $size="small"
        onClick={() => handleChangeModal()}
        data-testid="ai-assistant-modal-button"
      >
        <SparklesIcon />
        <Text $fs="t12" $fw="semiBold" component="span">
          <Trans i18nKey={`${translationPrefix}.title`} />
        </Text>
      </AssistantButton>

      {isOpen && (
        <ModalContent
          data={chatHistory}
          isLoading={isLoading}
          onSendMessage={handleSendMessage}
          onClose={() => handleChangeModal(false)}
          onSuggestedActionClick={handleSuggestedActionClick}
          onNewChat={handleNewChat}
          onSubmitButtonClick={handleSubmitButtonClick}
          onCancelButtonClick={handleCancelButtonClick}
        />
      )}
    </>
  );
};

export default AiAssistantModal;
